<script lang="ts" setup>
// #左兩張圖片，右一張圖片
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()
const imgData3 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_lg)
  const img2: Ref<Image> = ref(props.data.image_sm_top)
  const img3: Ref<Image> = ref(props.data.image_sm_bottom)
  imgData1.value = img1.value
  imgData2.value = img2.value
  imgData3.value = img3.value
}
</script>

<template>
  <div class="area">
    <div class="area__left">
      <figure class="area__pic2">
        <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
      </figure>
      <figure class="area__pic3">
        <Nimg :src="imgData3.link" :title="imgData3.title" :alt="imgData3.alt" format="webp" />
      </figure>
    </div>
    <figure class="area__pic">
      <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  @include max-media(480) {
    flex-wrap: wrap;
  }

  img {
    display: block;
    width: 100%;
  }

  &__pic {
    width: 50%;

    @include max-media(480) {
      width: 100%;
    }
  }

  &__left {
    width: 50%;
    padding-right: toRem(20);

    @include max-media(480) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding-right: 0;
      padding-bottom: toRem(20);
    }
  }

  &__pic2,
  &__pic3 {
    width: 49%;

    @include max-media(480) {
      width: calc(50% - toRem(7));
    }
  }

  &__pic2 {
    @include min-media(481) {
      margin-bottom: toRem(10);
    }
  }

  &__pic3 {
    @include min-media(481) {
      margin-left: auto;
    }

    @include max-media(480) {
      margin-top: 18%;
    }
  }
}
</style>
